function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 211.84345,-69.064528 480.01481,-230.81869 748.18617,-66.936184 677.95082,-373.41775 914.19702,-577.73879 603.45877,-605.40726 480.01481,-894.86207 356.57085,-607.53561 45.832601,-579.86713 282.0788,-373.41775 Z",
    style: {
      stroke: "#7f7f7f",
      strokeWidth: 75
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite);
export default __webpack_public_path__ + "static/media/iconFavorite.2dd88f659b057ce8d7f740f63cbc4779.svg";
export { ForwardRef as ReactComponent };